import { broadcastResponseToMainFrame } from './msalRedirectBridge';

/**
 * Path of the MSAL v5 redirect bridge. CRA cannot emit a second HTML entry
 * without ejecting, so the bridge lives behind this path branch in the single
 * entry point (index.tsx) instead of a separate page.
 */
export const REDIRECT_BRIDGE_PATH = '/redirect';

/** True when the current location is the redirect bridge page. */
export function isRedirectBridgePath(
  pathname: string = window.location.pathname,
): boolean {
  return pathname === REDIRECT_BRIDGE_PATH;
}

/**
 * Relays the auth response (popup, silent-iframe, or full-redirect flow) back
 * to the main window over a BroadcastChannel, then closes the bridge window.
 * Must run before PublicClientApplication / MsalProvider initialize, or MSAL
 * would consume the response first.
 */
export function runRedirectBridge(): Promise<void> {
  return broadcastResponseToMainFrame().catch((error) => {
    console.error('Redirect bridge failed:', error);
  });
}
